<template>
  <svg
    width="27px"
    height="23px"
    viewBox="0 0 27 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Fill 1</title>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Home"
        transform="translate(-156.000000, -3822.000000)"
        fill="#999999"
      >
        <g id="Footer" transform="translate(80.000000, 3433.000000)">
          <g id="Group-16" transform="translate(0.000000, 387.000000)">
            <path
              d="M102.725438,5.2 C101.753012,5.64381133 100.71835,5.93609467 99.6574376,6.06666667 C100.779286,5.37446867 101.613348,4.30033933 102.006104,3.042 C100.960029,3.66580933 99.8133596,4.102774 98.6174376,4.33333333 C97.6220969,3.23362 96.2093609,2.604342 94.7261043,2.6 C91.7426649,2.638064 89.3537243,5.08517533 89.3874376,8.06866667 C89.3870823,8.488532 89.4335963,8.90712333 89.5261043,9.31666667 C85.2092636,9.08342067 81.2019529,7.002398 78.5281051,3.60533333 C78.0547153,4.44346933 77.8068643,5.390086 77.8087709,6.35266667 C77.9123757,8.20894533 78.9024705,9.90210867 80.4694385,10.9026667 C79.6027709,10.9026667 78.3461043,10.6253333 78.3461043,10.218 L78.3461043,10.2873333 C78.1976148,12.8059013 79.8784273,15.0676933 82.3327709,15.652 C81.8253983,15.7787413 81.3044016,15.8427707 80.7814367,15.8426667 C80.4207873,15.8409593 80.0610556,15.8061453 79.7067709,15.7386667 C80.3611441,17.9428167 82.3571503,19.4773973 84.6554376,19.5433333 C82.7710616,21.0580413 80.4257975,21.8836289 78.0081043,21.8833333 C77.5795688,21.88498 77.1512977,21.861827 76.7254376,21.814 C79.1509568,23.4136873 81.9925696,24.2666667 84.8981043,24.2666667 C94.7174376,24.2666667 100.082104,15.9293333 100.082104,8.66666667 C100.082104,8.43266667 100.082104,8.19 100.082104,7.956 C101.11778,7.19917467 102.012483,6.266338 102.725438,5.2 Z"
              id="Fill-1"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon-twitter",
};
</script>

<style scoped lang="scss">
svg:hover path {
  fill: #666;
}
</style>
